import { render, staticRenderFns } from "./course-table.vue?vue&type=template&id=21f8b7ce&scoped=true&"
import script from "./course-table.vue?vue&type=script&lang=js&"
export * from "./course-table.vue?vue&type=script&lang=js&"
import style0 from "./course-table.vue?vue&type=style&index=0&id=21f8b7ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f8b7ce",
  null
  
)

export default component.exports